import DebugLogger from '@frontend/app/features/DebugLogger';
import Tracker from '@frontend/app/features/Tracker';
import queryString from 'query-string';

export default class CampaignTracking {
  static init() {
    const trackingRefKey = this.getTrackingRefKey();
    const query = queryString.parse(window.top.location.search);
    const campaignRef = query[trackingRefKey] || false;
    const logger = new DebugLogger(false); // NB: enable logging by setting false => true

    if (campaignRef) {
      logger.log(
        `Storing campaign name for ${Tracker.defaultLifetimeInHours()} hours: ${campaignRef}`
      );
      Tracker.store(trackingRefKey, campaignRef);
    } else {
      const currentCampaign = Tracker.get(trackingRefKey);
      if (currentCampaign) {
        const expirationInfo = Tracker.getExpirationInfo(trackingRefKey);
        logger.log(
          `Active campaign: ${currentCampaign}, expiration info: ${expirationInfo}`
        );
      } else {
        logger.log('No campaign name found.');
      }
    }
  }

  static getCurrentCampaign() {
    return Tracker.get(this.getTrackingRefKey());
  }

  static getTrackingRefKey() {
    return 'utm_campaign';
  }
}
